import { FC, PropsWithChildren } from "react";
import clsx from "clsx";
import { InputLabelProps } from "./types";
import styles from "./styles.scss";

export const InputLabel: FC<PropsWithChildren<InputLabelProps>> = ({
  children,
  labelClassName,
  mandatory = false,
  label,
  subLabel,
}) => {
  return (
    <label className={styles.label}>
      {label && (
        <span className={clsx(styles.labelText, labelClassName)}>
          {label}
          {mandatory && <span className={styles.asterix}> *</span>}
        </span>
      )}
      {subLabel && (
        <span className={clsx(styles.labelText, labelClassName)}>
          {subLabel}
        </span>
      )}
      {children}
    </label>
  );
};
